<template>
	<div class="card">
		<div class="card-body">
			<div class="flex flex-wrap items-center justify-between gap-3">
				<div class="card-title flex items-center gap-2">
					<span>{{ _tr('location.AllLocations') }}</span>
					<span
						class="loading loading-spinner loading-xs"
						v-if="locationStore.loadingMap['listLocations']"></span>
				</div>
				<div class="flex flex-row items-center gap-2">
					<label class="input input-sm">
						<Search size="16" />
						<input
							type="search"
							:placeholder="_tr('location.filter')"
							:aria-label="_tr('location.filter')"
							v-model="search" />
					</label>

					<button class="btn btn-soft btn-primary btn-sm" @click="openAddModal">
						{{ _tr('location.addNewLocation') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { _translations } from './_translations'
	import { useI18n } from 'vue-i18n'
	import { Search } from 'lucide-vue-next'
	import { useLocationData } from './_useLocation'
	import { useVfm } from '@/libs/modals'
	import { useLocationStore } from '@/stores/location.store'

	const { t: _tr } = useI18n(_translations)
	const { search } = useLocationData()
	const locationStore = useLocationStore()
	const vfm = useVfm()

	const openAddModal = () => {
		vfm.open('add-location-modal')
	}
</script>
